<template>
	<v-list
		outlined
		dense
		class="pa-0"
		color="transparent"
		style="border: 1px solid #cfcfca !important"
		rounded
	>
		<v-list-item class="px-0">
			<v-list-item-avatar class="ma-0">
				<v-icon color="primary">mdi-cash-register</v-icon>
			</v-list-item-avatar>
			<v-list-item-content class="pa-0" v-if="$mq == 'lg'">
				<v-list-item-title style="font-weight-bold text-grey text--darken-1"
					>Terminal {{ pd0 ? pd0.pd0nome : "001" }}
				</v-list-item-title>
				<v-list-item-subtitle style="text-grey text--darken-1">{{
					dc4 ? dc4.dc4nome : ""
				}}</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-content class="pa-0 pr-2" v-else>
				<v-list-item-title style="font-weight-bold text-grey text--darken-1"
					>{{ pd0 ? pd0.pd0nome : "001" }}
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
export default {
	computed: {
		dc4: {
			get() {
				return this.$store.state.dc4.dc4;
			},
		},
		pd0: {
			get() {
				return this.$store.state.dc4.pd0;
			},
		},
	},
};
</script>

<style>
</style>